import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { CalculationReturnOfInvestmentsService } from '@/infra/services/calculation-return-of-investments';

interface GetReturnOfInvestmentsResultParams {
	id: string;
}

const Service = CalculationReturnOfInvestmentsService.getInstance();

export const useGetReturnOfInvestmentsResult = (params: GetReturnOfInvestmentsResultParams) => {
	return useQuery({
		queryKey: [QUERY_KEYS.GET_RETURN_OF_INVESTMENTS, params],
		queryFn: async () => Service.getResult(params),
		enabled: !!params.id,
		retry: 0
	});
};
